<template>
  <div>
    <div class="list-item-icon">
      <b-icon
        icon="account">
      </b-icon>
    </div>
    <div class="list-item-content">
      <p>
        <strong>{{ rideName }}</strong>
        <br>
        Jinete
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rider: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    rideName () {
      return `${this.rider.name} ${this.rider.lastname}`
    }
  }
}
</script>
